import { CRTMSG, DELMSG } from 'src/Helper/toastmsg';
import {
  PAYMENT_CREATE, PAYMENT_LIST, PAYMENT_NUMBER, PAYMENT_SINGLE,
  PAYMENT_UPDATE, PAYMENT_DELETE, PAYMENT_VENPUR,
  PAYMENT_PARTICULAR, PAYMENT_TOTALS,
  CLEAR_PAYMENT_TEMP_STATES, CLEAR_PAYMENT_STATES, PAYMENT_SEND,
} from '../../../../Helper/actionsTypes';

const paymentReducer = (state = {}, action) => {
  const { code, results, message } = action.payload || ''
  switch (action.type) {
    case PAYMENT_PARTICULAR: {
      return { ...state, particular: action.payload };
    }
    case PAYMENT_TOTALS: {
      return { ...state, totals: action.payload };
    }
    case PAYMENT_LIST: {
      return code === 200
        ? { ...state, list: results }
        : { ...state, list: [] };
    }
    case PAYMENT_VENPUR: {
      return code === 200
        ? { ...state, vendPur: results }
        : { ...state, vendPur: [] };
    }
    case PAYMENT_SEND: {
      return code === 200
        ? { ...state, sent: true }
        : { ...state, sent: false };
    }
    case 'PAID_FROM':{
      return {...state, mode:action.payload}
    }
    case 'PAYMENT_VEN': {
      return  { ...state, vendPur: action.payload }
    }
    case PAYMENT_NUMBER: {
      return code === 200
        ? { ...state, number: results.payment_no }
        : { ...state, number: '' };
    }
 case 'PAYMENT_CUSTINV_UPT':{
   return {...state, custInv:action.payload}
 }
    case PAYMENT_SINGLE: {
      return code === 200
        ? { ...state, single: results }
        : { ...state, single: [] };
    }

    case PAYMENT_DELETE: {
      return code === 200
      ? { ...state, itemDeleted: true, message }
      : code === 400 ? { ...state, itemDeleted: false, badReq: true, message }
        : code === 500 ? { ...state, itemDeleted: false, message: DELMSG }
          : { ...state, itemDeleted: false, message };
  }

    case PAYMENT_CREATE: {
      return code === 200 ? { ...state, itemSaved: true, message }
        : code === 500 ? { ...state, itemSaved: false, message: CRTMSG }
          : { ...state, itemSaved: false, message };
    }

    case PAYMENT_UPDATE: {
      return code === 200
        ? { ...state, itemUpdated: true, update: action.error, message}
        : code === 400 ? { ...state, itemUpdated: false, badReq: true, message }
        : code === 500 ? { ...state, itemUpdated: false, message: DELMSG }
        : { ...state, itemUpdated: false, message };
      }
    case CLEAR_PAYMENT_TEMP_STATES: return {
      ...state,
      itemDeleted: null,
      itemSaved: null,
      itemUpdated: null,
      create: {},
      update: {},
      message:null,
      mode:null,
      send:null
    };
    case CLEAR_PAYMENT_STATES: return {
      particular: [],
      totals: { amount: 0, qty: 0 }
    };
    default: return state;
  }
};

export default paymentReducer;